import { combineReducers } from 'redux';
import { sprintReducer } from '../../../modules/game-sprint/store/reducers/sprintReducer';
import { audioReducer } from '../../../modules/game-audio/store/reducers/audioReducer';
import { authReducer } from '../../../modules/Login';
import { bookReducer, userWordsReducer } from '../../../modules/textbook';
import { statsReducer } from '../../../modules/Statistics';

export const rootReducer = combineReducers({
  auth: authReducer,
  book: bookReducer,
  userWords: userWordsReducer,
  sprint: sprintReducer,
  audio: audioReducer,
  stats: statsReducer,
});

export type RootState = ReturnType<typeof rootReducer>;
